import request from "@/http/request.js";
import baseUrl from "@/http/config.js";

const api = {};

//post 登录
api.login = (obj) => {
	return request({
		url: baseUrl + "/user/login",
		method: "post",
		data: obj,
	});
};
//post 退出登录
api.zhuxiao = (obj) => {
	return request({
		url: baseUrl + "/user/zhuxiao",
		method: "post",
		data: obj,
	});
};
//post 获取验证码
api.sms = (obj) => {
	return request({
		url: baseUrl + "/user/sms",
		method: "post",
		data: obj,
	});
};
//get 获取背景图
api.getBgList = (obj) => {
	return request({
		url: baseUrl + "/basic/getBgList",
		method: "get",
		params: obj,
	});
};
//get 获取案例精选
api.getCaseList = (obj) => {
	return request({
		url: baseUrl + "/article/getCaseList",
		method: "get",
		params: obj,
	});
};
//get 获取本周推荐
api.getCaseList2 = (obj) => {
	return request({
		url: baseUrl + "/article/getCaseList2",
		method: "get",
		params: obj,
	});
};
//get 获取 文章列表
api.getArticlePage = (obj) => {
	return request({
		url: baseUrl + "/article/getArticlePage",
		method: "get",
		params: obj,
	});
};
//get 获取 文章详情
api.getArticleById = (obj) => {
	return request({
		url: baseUrl + "/article/getArticleById",
		method: "get",
		params: obj,
	});
};
//get 获取 我点赞的 列表
api.getUpvoteList = (obj) => {
	return request({
		url: baseUrl + "/article/getUpvoteList",
		method: "get",
		params: obj,
	});
};
//get 获取 我浏览的 列表
api.getBrowseList = (obj) => {
	return request({
		url: baseUrl + "/article/getBrowseList",
		method: "get",
		params: obj,
	});
};
//post 点赞
api.postUpvote = (obj) => {
	return request({
		url: baseUrl + "/article/postUpvote",
		method: "post",
		data: obj,
	});
};
//post 取消点赞
api.deleteUpvote = (obj) => {
	return request({
		url: baseUrl + "/article/deleteUpvote",
		method: "post",
		data: obj,
	});
};
export default api;